import { combineReducers } from "redux";
import userLogin from "./UserLogin";
import userOtp from "./UserOtp";
import { userAddFaq, userDeleteFaq, userFaq, userFaqSection, userUpdateFaq } from "./UserFAQ";
import userRegistration from "./UserRegistration";
import userLogout from "./UserLogout";
import { userShareTrip, userTrip } from "./UserTrip";
import { userAutoComplete, userDirection, userGeocode, userNearBySearch, userPlaceDetails,userLocationCheck } from "./UserGoogleMap";
import { userCancelReason, userCancelTrip, userRateCalculation, userRefundPrice, userRentalSlab, userTripCheckout, userTripSlab } from "./UserCustomerTrip";
import { userProfile, userUpdateProfile, userVerifyProfile } from "./UserProfile";
import { userPaymentHash, userPaymentMethod, userPaymentVerify } from "./UserPayment";
import { userPayu, userPayuResponse } from "./UserPayu";
import { commonReducer } from "./CommonReducer";
import { userCashFree,userCashFreeResponse } from "./UserCashFreeReducer";
import {userCouponList, userCouponApply, userRentalCouponApply} from "./UserCouponReducer";

const rootReducer = combineReducers({
  userLogin: userLogin,
  userOtp: userOtp,
  userFaq: userFaq,
  userAddFaq: userAddFaq,
  userUpdateFaq: userUpdateFaq,
  userDeleteFaq: userDeleteFaq,
  userRegistration: userRegistration,
  userFaqSection:userFaqSection,
  userLogout:userLogout,
  userTrip:userTrip,
  userShareTrip:userShareTrip,
  userPlaceDetails:userPlaceDetails,
  userAutoComplete:userAutoComplete,
  userDirection:userDirection,
  userGeocode:userGeocode,
  userRateCalculation:userRateCalculation,
  userProfile:userProfile,
  userUpdateProfile:userUpdateProfile,
  userTripCheckout:userTripCheckout,
  userPaymentVerify:userPaymentVerify,
  userPaymentHash: userPaymentHash,
  userPayu:userPayu,
  userNearBySearch:userNearBySearch,
  userPayuResponse:userPayuResponse,
  userRentalSlab:userRentalSlab,
  userCancelTrip:userCancelTrip,
  userCancelReason:userCancelReason,
  userRefundPrice:userRefundPrice,
  userTripSlab:userTripSlab,
  userVerifyProfile:userVerifyProfile,
  commonReducer:commonReducer,
  userCashFree:userCashFree,
  userCashFreeResponse: userCashFreeResponse,
  userPaymentMethod:userPaymentMethod,
  userCouponApply:userCouponApply,
  userCouponList:userCouponList,
  userRentalCouponApply:userRentalCouponApply,
  userLocationCheck:userLocationCheck,
});

export default rootReducer;
